<template>
  <div class="container">
    <div class="oa-breadcrumb">
      <span class="breadcrumb-item">
        <a class="breadcrumb-link" @click="goIndex">{{this.$route.params.language == 'zh' ? '首页' : 'Home'}}</a>
        <span class="sep">{{separator}}</span>
      </span>
      <app-breadcrumb-item v-for="item in items" v-bind:item="item"></app-breadcrumb-item>
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss" scoped>
  .breadcrumb-link{
    cursor: pointer;
  }
</style>
<script>
  import AppBreadcrumbItem from './AppBreadcrumbItem';

  export default {
    name: 'AppBreadcrumb',
    props: {
      separator: {
        type: String,
        default: '/',
      },
      items: {
        type: Array,
      },
    },
    components: {
      AppBreadcrumbItem,
    },
    methods: {
      goIndex() {
        location.href = `${process.env.SITE_URL}/#/${this.$route.params.language}`;
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "../scss/_mui.scss";

  .oa-breadcrumb {
    padding: 15px 0;
    font-size: 12px;
    color: $grayDarker;
    .sep,
    a {
      color: $grayDark;
      &:hover {
        color: $grayDarker;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AppBreadcrumb.vue?0309b2f0